import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
	modalIsOpen: false,
	data: [],
}

export const modalSlice = createSlice({
	name: 'modal',
	initialState,
	reducers: {
		showModal(state, action: PayloadAction<object[]>) {
			state.modalIsOpen = true
			state.data = action.payload
		},
		removeModal(state, action) {
			state.modalIsOpen = false
			state.data = []
		},
	},
})

export const { showModal, removeModal } = modalSlice.actions
